import {
  post_func,
  post_funcCallback,
  get_upload_url as getUploadUrl
} from '$common/utils/curl/boss-curl';
import JsCrypto from '$proDirname/app/service/util-service/js-crypto';
import axios from 'axios';
import md5 from 'md5';
import Store from "$common/utils/store";

export const get_upload_url = getUploadUrl

const jsCrypto = JsCrypto(1, true);
export const bossWebAxios = (params, url, config = {}) => post_func(params, url, config).then(res => {
  if (typeof config?.success === 'function' && res?.rspCd?.toString() === '00000') {
    config.success(res);
  } else if (typeof config?.fail === 'function') {
    config.fail(res);
  }
  return res;
}).catch(res => {
  if (typeof config?.fail === 'function') {
    config.fail(res);
  }
  return res;
})

export const upload = (data, url, cb) => {
  return axios({
    url,
    data,
    method: 'post',
    headers: {
      TermTyp: 'merchantWEB', //
      appVersion: '1.0',
      appId: 'SuperMerchant',
      authorization: Store.loadObject('access_token'),
      deviceid: Store.loadObject('deviceId'),
      operatorno: Store.loadObject('operator_no'),
      contentType: false,
      processData: false,
      'dark-flower': md5(Cookies.get('scenes') + jsCrypto.CryptoJSKeys)
    },
    contentType: false,
    processData: false,
    onUploadProgress: function (e) {
      cb && cb(e)
    }
  }).then(res => {
    try {
      res.data = JSON.parse(decodeURIComponent(jsCrypto.decrypt(res.data)))
    } catch (err) {
    }
    post_funcCallback(res);
    return res.data || res;
  })
}
